import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';

const card = { background: 'var(--surface)', border: '1px solid #e2e8f0', borderRadius: 12, padding: 18, marginBottom: 18 };
const title = { fontSize: 15, fontWeight: 700, marginBottom: 12, color: '#0f172a' };
const inp = { padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 13, width: 200 };
const lbl = { fontSize: 11, color: '#64748b', marginBottom: 3 };

export default function CambiaPasswordCard() {
  const [oldP, setOldP] = useState('');
  const [newP, setNewP] = useState('');
  const [newP2, setNewP2] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (newP !== newP2) { toast.error('Le due nuove password non coincidono'); return; }
    if (newP.length < 6) { toast.error('Nuova password troppo corta (min 6 caratteri)'); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/password`, { old_password: oldP, new_password: newP });
      toast.success('Password aggiornata');
      setOldP(''); setNewP(''); setNewP2('');
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
    setBusy(false);
  };

  return (
    <div style={card}>
      <div style={title}>Cambia la mia password</div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={lbl}>Password attuale</span>
          <input style={inp} type="password" autoComplete="current-password"
                 value={oldP} onChange={(e) => setOldP(e.target.value)} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={lbl}>Nuova password</span>
          <input style={inp} type="password" autoComplete="new-password"
                 value={newP} onChange={(e) => setNewP(e.target.value)} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={lbl}>Ripeti nuova password</span>
          <input style={inp} type="password" autoComplete="new-password"
                 value={newP2} onChange={(e) => setNewP2(e.target.value)} />
        </div>
        <button className="btn btn-primary" disabled={busy || !oldP || !newP || !newP2} onClick={submit}>
          Aggiorna
        </button>
      </div>
    </div>
  );
}
